import {TActionStep, TUIActionPayload} from 'src/containers/Triggers/types';

type TActionNodeData = {
  step: TActionStep<TUIActionPayload>;
  ui: {
    isActionSelected: boolean;
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const makeActionNodeData = (step: TActionStep & any): TActionNodeData => ({
  step,
  ui: {
    isActionSelected: false,
  },
});

const INITIAL_DELAY = 'P0DT0H0M0S';

export type {TActionNodeData};
export {INITIAL_DELAY, makeActionNodeData};
